import React, { useEffect, useState } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useParams } from "react-router-dom";

import CreditsContent from "../components/credits/CreditsContent";
import ContentAPI from "../services/ContentAPI";

const CONTENT_REQUEST_PARAMS = {
  version: 6000,
  platform: "web",
  runtimePlatform: "web",
};

const getApiResponseData = (response) =>
  response?.data?.data ?? response?.data ?? null;

const SystemCreditsPage = () => {
  const { systemId } = useParams();
  const [system, setSystem] = useState(null);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    let cancelled = false;
    setStatus("loading");

    ContentAPI.get(`systems/${systemId}`, { params: CONTENT_REQUEST_PARAMS })
      .then((response) => {
        if (!cancelled) {
          setSystem(getApiResponseData(response));
          setStatus("ready");
        }
      })
      .catch((error) => {
        if (!cancelled) {
          console.error("Failed to fetch system credits", error);
          setStatus("error");
        }
      });

    return () => {
      cancelled = true;
    };
  }, [systemId]);

  return (
    <Box
      component="main"
      sx={{
        minHeight: "100vh",
        boxSizing: "border-box",
        color: "#f2fffc",
        background:
          "radial-gradient(circle at top left, rgba(39, 94, 107, 0.28), transparent 34%), linear-gradient(180deg, #060b10, #0c141d)",
        px: { xs: 2.5, sm: 4 },
        py: { xs: 4, sm: 7 },
      }}
    >
      <Box sx={{ width: "100%", maxWidth: 840, mx: "auto" }}>
        {status === "loading" && (
          <Box role="status" sx={{ py: 10, textAlign: "center" }}>
            <CircularProgress color="inherit" size={28} />
            <Typography sx={{ mt: 2 }}>Loading credits…</Typography>
          </Box>
        )}

        {status === "error" && (
          <Box role="alert" sx={{ py: 10, textAlign: "center" }}>
            <Typography component="h1" sx={{ fontSize: "1.5rem", fontWeight: 800 }}>
              Credits could not be loaded
            </Typography>
            <Typography sx={{ mt: 1, color: "rgba(242, 255, 252, 0.72)" }}>
              Please try again later.
            </Typography>
          </Box>
        )}

        {status === "ready" && (
          <>
            <Box component="header" sx={{ mb: 4 }}>
              <Typography
                sx={{ color: "rgba(161, 241, 224, 0.9)", fontSize: "0.75rem", fontWeight: 800, letterSpacing: "0.12em", textTransform: "uppercase" }}
              >
                Credits &amp; Licensing
              </Typography>
              <Typography
                component="h1"
                sx={{ mt: 0.75, fontSize: { xs: "2rem", sm: "2.65rem" }, fontWeight: 900, lineHeight: 1.12 }}
              >
                {system?.name || "System"}
              </Typography>
              {system?.description && (
                <Typography sx={{ mt: 1.5, maxWidth: 720, color: "rgba(242, 255, 252, 0.72)", fontSize: "1.05rem", lineHeight: 1.65 }}>
                  {system.description}
                </Typography>
              )}
            </Box>
            <CreditsContent credits={system?.credits} />
          </>
        )}
      </Box>
    </Box>
  );
};

export default SystemCreditsPage;
